import { User } from '../types/index';

const firstNames = ['Adebayo','Chioma','Emeka','Fatima','Grace','Ibrahim','Joy','Kelechi','Lola','Musa','Ngozi','Obinna','Patricia','Quadri','Ruth','Samuel','Tope','Uche','Victoria','Wale','Amaka','Bola','Chidi','Dayo','Efua','Femi','Gbenga','Halima','Ife','Jide'];
const lastNames = ['Adeleke','Balogun','Chukwu','Dada','Eze','Fashola','Ganiyu','Hassan','Ibeji','Johnson','Kalu','Lawal','Martins','Nwosu','Obi','Peters','Quadri','Rabiu','Smith','Taiwo','Usman','Vincent','Williams','Yusuf','Zubair','Abubakar','Bankole','Coker','Diallo','Eze'];
const organizations = ['Lendsqr','Irorun','Lendstar','Kuda','Cowrywise','PiggyVest','Carbon','FairMoney','Renmoney','Palmpay'];
const statuses: User['status'][] = ['active','active','active','inactive','pending','blacklisted'];
const banks = ['Access Bank','GTBank','First Bank','Zenith Bank','UBA','Fidelity Bank','Sterling Bank','Polaris Bank'];
const sectors = ['FinTech','Banking','Education','Healthcare','Retail','Technology','Agriculture','Real Estate'];
const residences = ["Parent's Apartment","Rented Apartment","Own Home"];
const educations = ['B.Sc','B.A','M.Sc','HND','OND','SSCE'];
const employmentStatuses = ['Employed','Self-employed','Unemployed','Student'];
const relationships = ['Sibling','Friend','Colleague','Spouse','Parent'];

function random<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

function randomNum(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomPhone(): string {
  return `0${random(['7','8','9'])}${randomNum(10000000, 99999999)}`;
}

function randomDate(): string {
  const start = new Date(2019, 0, 1);
  const end = new Date(2024, 11, 31);
  const date = new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  );
  return date.toLocaleDateString('en-NG', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function generateUsers(count: number, startIndex: number): User[] {
  return Array.from({ length: count }, (_, i) => {
    const firstName = random(firstNames);
    const lastName = random(lastNames);
    const org = random(organizations);
    const id = startIndex + i + 1;

    return {
      id: `USR-${String(id).padStart(4, '0')}`,
      firstName,
      lastName,
      email: `${firstName.toLowerCase()}.${lastName.toLowerCase()}${randomNum(1, 99)}@${org.toLowerCase().replace(/\s/g, '')}.com`,
      phone: randomPhone(),
      username: `${firstName.toLowerCase()}_${lastName.toLowerCase()}${randomNum(1, 999)}`,
      organization: org,
      dateJoined: randomDate(),
      status: random(statuses),
      accountBalance: randomNum(5000, 5000000),
      bvn: `2${randomNum(1000000000, 9999999999)}`,
      accountNumber: `${randomNum(1000000000, 9999999999)}`,
      bank: random(banks),
      gender: random(['Male', 'Female']),
      maritalStatus: random(['Single', 'Married', 'Divorced']),
      children: randomNum(0, 5),
      residenceType: random(residences),
      educationLevel: random(educations),
      employmentStatus: random(employmentStatuses),
      employmentSector: random(sectors),
      employmentDuration: `${randomNum(1, 10)} years`,
      officeEmail: `${firstName.toLowerCase()}@${org.toLowerCase().replace(/\s/g, '')}.com`,
      monthlyIncome: randomNum(30000, 500000),
      loanRepayment: randomNum(0, 50000),
      twitter: `@${firstName.toLowerCase()}${randomNum(1, 999)}`,
      facebook: `fb.com/${firstName.toLowerCase()}.${lastName.toLowerCase()}`,
      instagram: `@${firstName.toLowerCase()}_${lastName.toLowerCase()}`,
      tier: randomNum(1, 3),
      guarantor1FirstName: random(firstNames),
      guarantor1LastName: random(lastNames),
      guarantor1Phone: randomPhone(),
      guarantor1Email: `guarantor${randomNum(1, 999)}@gmail.com`,
      guarantor1Relationship: random(relationships),
      guarantor2FirstName: random(firstNames),
      guarantor2LastName: random(lastNames),
      guarantor2Phone: randomPhone(),
      guarantor2Email: `guarantor${randomNum(1, 999)}@gmail.com`,
      guarantor2Relationship: random(relationships),
    };
  });
}